import './EnterButton.scss'
import React, { Component } from 'react'

class EnterButton extends Component {
  constructor (props) {
    super(props)
    this.handleKeyUp = this.handleKeyUp.bind(this)
    this.handleEnter = this.handleEnter.bind(this)
  }

  componentWillMount () {
    window.addEventListener('keyup', this.handleKeyUp)
  }

  componentWillUnmount () {
    window.removeEventListener('keyup', this.handleKeyUp)
  }

  handleKeyUp (e) {
    if (e.keyCode === 13) {
      this.handleEnter()
    }
  }

  handleEnter () {
    if (!this.props.disabled) {
      this.props.onEnter()
    }
  }

  render () {
    return (
      <div className='EnterButton'>
        <button {...this.props}
          className='EnterButton_button'
          onClick={this.handleEnter}>
          {this.props.children}
        </button>
        {!this.props.disabled && (
          <div className='EnterButton_enter'>
            Press Enter
          </div>
        )}
      </div>
    )
  }
}

export default EnterButton



// WEBPACK FOOTER //
// ./src/lib/EnterButton.js